<template>
    <div id="infinite-list" class="main-wrapper scroll-y custom-scrollbar with-tabs view-brands">

        <page-title :title="'Nasze marki'" :back="true"></page-title>

        <div v-for="(item,index) in brands" :key="item.slug">
            <item-brand
                    :index="index+1"
                    :slug="item.slug"
                    :title="item.title"
                    :description="item.description"
                    :image="item.image"
                    :url="item.url"
                    :url_label="item.url_label">
            </item-brand>
        </div>

    </div>
</template>

<script>
    import api from '@/services/Api';

    import PageTitle from '@/components/PageTitle.vue';
    import ItemBrand from '@/items/ItemBrand';

    export default {
        name: 'BrandsIndex',
        components: { PageTitle, ItemBrand },
        data(){
            return {
                brands: [],
            }
        },
        mounted(){
            this.getBrands();
        },
        methods: {
            // todo refactor to vuex
            getBrands(){
                let url = 'knowledges/brands?per_page=100';
                api({url: url, method: 'GET'})
                    .then(resp => {
                        this.brands = resp.data.data;
                    })
            }
        }
    }
</script>

<style lang="scss" scoped>
    ion-list {
        margin: 0;
        background: none;
    }
</style>
